import { LogOut } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface Props {
  open: boolean;
  channelLabel: string; // ex.: "@gauleslive" — usado no título
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/**
 * AlertDialog destructive pra confirmar desconexão de plataforma (#100).
 *
 * Copy travada no roteiro Fase 1 §C.5. Safe default ("Manter conectado")
 * fica focado por default e visualmente primary, evitando confirmação
 * acidental por Enter que encerraria a live no painel.
 *
 * Semântica Radix: AlertDialogCancel = "Manter conectado" (sai sem ação);
 * AlertDialogAction = "Desconectar" (confirma + sai). Ambos fecham o
 * dialog automaticamente.
 */
export function DisconnectAlertDialog({ open, channelLabel, onOpenChange, onConfirm }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <div className="flex items-center gap-2">
          <LogOut className="w-5 h-5 text-destructive" aria-hidden="true" />
          <AlertDialogTitle>Desconectar {channelLabel}?</AlertDialogTitle>
        </div>
        <AlertDialogDescription>
          A live ativa será encerrada no painel. Você pode reconectar a qualquer momento.
        </AlertDialogDescription>
        <div className="flex justify-end gap-2 mt-2">
          <AlertDialogAction asChild>
            <button
              type="button"
              onClick={onConfirm}
              className="h-11 min-w-[44px] px-4 rounded-md text-destructive border border-destructive/40 hover:bg-destructive-soft transition-colors duration-fast"
            >
              Desconectar
            </button>
          </AlertDialogAction>
          <AlertDialogCancel asChild>
            <button
              type="button"
              autoFocus
              className="h-11 min-w-[44px] px-4 rounded-md bg-primary text-primary-fg font-semibold"
            >
              Manter conectado
            </button>
          </AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
